function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M27 30a3 3 0 003-3V15.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5V27a1 1 0 01-1 1H5a1 1 0 01-1-1V5a1 1 0 011-1h11.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5H5a3 3 0 00-3 3v22a3 3 0 003 3h22z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29 2h-8.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h6.086L12.293 18.293a1 1 0 001.414 1.414L28 5.414V11.5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5V3a1 1 0 00-1-1z",
  fill: "currentColor"
})));